import { AcceptanceProtocolItem } from '@/entities/models/AcceptanceProtocolItem';
export class AcceptanceProtocol {
    id;
    company;
    status;
    createdAt;
    createdBy;
    acceptedAt;
    acceptedBy;
    reason;
    items;
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => AcceptanceProtocol.define(et));
        }
        else if (data != null) {
            return AcceptanceProtocol.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let acceptanceProtocol = new AcceptanceProtocol();
        acceptanceProtocol.id = data.Id;
        acceptanceProtocol.company = data.Company;
        acceptanceProtocol.status = data.Status;
        acceptanceProtocol.createdAt = data.CreatedAt;
        acceptanceProtocol.createdBy = data.CreatedBy;
        acceptanceProtocol.acceptedAt = data.ResolvedAt;
        acceptanceProtocol.acceptedBy = data.ResolvedBy;
        acceptanceProtocol.reason = data.RejectionReason;
        if (data.Items)
            acceptanceProtocol.items = AcceptanceProtocolItem.fromApi(data.Items);
        return acceptanceProtocol;
    }
}
